import React from 'react';
import { motion } from 'framer-motion';
import HeroSection from '../components/HeroSection';
import ServicesPreview from '../components/ServicesPreview';
import ServicesComponent from '../components/ServicesComponent';
import NewHeroSection from '../components/NewHeroSection';
import WhyChooseSection from '../components/WhyChooseSection';
import CoverageSection from '../components/CoverageSection';
import ServicesOverview from '../components/ServicesOverview';
import CallToAction from '../components/CallToAction';
import Cta from '../components/NewCallToAction';
import './Home.css';
import { Helmet } from 'react-helmet';
import { FaBolt, FaAward, FaBus, FaShieldAlt, FaMapMarkerAlt, FaIndustry, FaPaintBrush, FaCog, FaHammer } from 'react-icons/fa';

// Add JSON-LD schema structured data
const LocalBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Abraj Al Dhafna Trading & Contracting WLL",
  "image": "https://abrajaldhafna.com/logo.jpeg",
  "description": "ISO certified construction manpower supply and subcontracting services in Qatar",
  "url": "https://abrajaldhafna.com",
  "telephone": "+97444170859",
  "email": "abrajaldhafna2014@gmail.com",
  "priceRange": "Custom quotes",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "Qatar",
    "addressLocality": "Doha"
  },
  "sameAs": [
    "https://www.linkedin.com/company/abraj-al-dhafna",
    "https://www.facebook.com/abrajaldhafna",
    "https://wa.me/97455994434",
    "https://maps.google.com/?cid=YOUR_GOOGLE_BUSINESS_CID"
  ],
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "25.2854",
    "longitude": "51.5310"
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "07:00",
      "closes": "18:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Saturday",
      "opens": "08:00",
      "closes": "14:00"
    }
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "45",
    "bestRating": "5",
    "worstRating": "1"
  }
};

const BreadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://abrajaldhafna.com"
    }
  ]
};

const Home = () => {
  const handleContactClick = (type) => {
    switch (type) {
      case 'phone':
        window.open('tel:+97444170859', '_self');
        break;
      case 'email':
        window.open('mailto:abrajaldhafna2014@gmail.com', '_self');
        break;
      case 'whatsapp':
        window.open('https://wa.me/97455994434', '_blank');
        break;
      default:
        break;
    }
  };

  return (
    <main className="home-page" id="main-content" role="main" tabIndex={-1} aria-label="Homepage main content">
      <Helmet>
        <title>Top Construction Manpower Supply & Subcontracting Qatar | ISO Certified</title>

        <meta
          name="description"
          content="Qatar's #1 ISO certified construction manpower supply & subcontracting company. Mobile teams of electricians, plumbers, masons, welders & fit-out specialists available 24/7 in Doha, Lusail & West Bay."
        />

        <meta name="keywords" content="construction manpower supply Qatar, manpower agency Doha, subcontracting companies in Qatar, skilled labor supply, civil construction workers, MEP subcontractors, electricians Qatar, plumbers Doha, welders Qatar, hiring construction workers, ISO certified contracting company, fit-out contractors Doha, industrial manpower Qatar" />

        <link rel="canonical" href="https://abrajaldhafna.com/" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebSite",
                "@id": "https://abrajaldhafna.com/#website",
                "url": "https://abrajaldhafna.com/",
                "name": "Abraj Al Dhafna Trading & Contracting WLL",
                "publisher": { "@id": "https://abrajaldhafna.com/#organization" },
                "inLanguage": "en"
              },
              {
                "@type": "Organization",
                "@id": "https://abrajaldhafna.com/#organization",
                "name": "Abraj Al Dhafna Trading & Contracting WLL",
                "url": "https://abrajaldhafna.com/",
                "logo": "https://abrajaldhafna.com/logo.jpeg",
                "email": "abrajaldhafna2014@gmail.com",
                "telephone": "+97444170859",
                "foundingDate": "2014",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Doha",
                  "addressCountry": "QA"
                },
                "sameAs": [
                  "https://www.linkedin.com/company/abraj-al-dhafna",
                  "https://www.facebook.com/abrajaldhafna",
                  "https://wa.me/97455994434",
                  "https://maps.google.com/?cid=YOUR_GOOGLE_BUSINESS_CID"
                ]
              },
              {
                "@type": "LocalBusiness",
                "@id": "https://abrajaldhafna.com/#localbusiness",
                "name": "Abraj Al Dhafna Trading & Contracting WLL",
                "image": "https://abrajaldhafna.com/logo.jpeg",
                "url": "https://abrajaldhafna.com/",
                "telephone": "+97444170859",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Doha",
                  "addressCountry": "QA"
                },
                "sameAs": [
                  "https://www.linkedin.com/company/abraj-al-dhafna",
                  "https://www.facebook.com/abrajaldhafna",
                  "https://wa.me/97455994434",
                  "https://maps.google.com/?cid=YOUR_GOOGLE_BUSINESS_CID"
                ],
                "areaServed": {
                  "@type": "Country",
                  "name": "Qatar"
                },
                "priceRange": "$$",
                "openingHoursSpecification": [
                  {
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
                    "opens": "00:00",
                    "closes": "23:59"
                  }
                ],
                "hasOfferCatalog": {
                  "@type": "OfferCatalog",
                  "name": "Construction Services",
                  "itemListElement": [
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Manpower Supply",
                        "description": "Skilled and unskilled labor supply for construction and industrial projects."
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Civil Subcontracting",
                        "description": "Complete civil works subcontracting including concrete, blockwork, and plastering."
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "MEP Services",
                        "description": "Mechanical, Electrical, and Plumbing installation and maintenance."
                      }
                    }
                  ]
                }
              },
              {
                "@type": "Service",
                "@id": "https://abrajaldhafna.com/#manpower",
                "name": "Construction Manpower Supply Qatar",
                "provider": { "@id": "https://abrajaldhafna.com/#localbusiness" },
                "areaServed": "Qatar",
                "description": "Skilled and certified construction manpower supply in Qatar including electricians, plumbers, masons, welders, helpers, and supervisors."
              },
              {
                "@type": "Service",
                "@id": "https://abrajaldhafna.com/#subcontracting",
                "name": "Construction Subcontracting Qatar",
                "provider": { "@id": "https://abrajaldhafna.com/#localbusiness" },
                "areaServed": "Qatar",
                "description": "Complete construction subcontracting services in Qatar including MEP, civil works, painting, and industrial services."
              },
              {
                "@type": "BreadcrumbList",
                "@id": "https://abrajaldhafna.com/#breadcrumb",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://abrajaldhafna.com/"
                  }
                ]
              }
            ]
          })}
        </script>
      </Helmet>

      <section aria-hidden="true" style={{ position: "absolute", left: "-9999px" }}>
        <h1>Construction Manpower Supply & Subcontracting Company in Qatar</h1>
        <p>
          Abraj Al Dhafna Trading & Contracting WLL is a leading ISO certified construction
          manpower supply and subcontracting company in Qatar. We provide skilled electricians,
          plumbers, masons, welders, MEP specialists, and construction helpers across Doha,
          Lusail, West Bay, and all major project locations in Qatar.
        </p>
      </section>

      {/* Add skip-to-content link for accessibility */}
      <a href="#main-content" className="skip-to-content" tabIndex={0} style={{ position: 'absolute', left: '-9999px', top: 'auto', width: '1px', height: '1px', overflow: 'hidden', zIndex: 1000, background: '#fff', color: '#005884', padding: '8px 16px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }} onFocus={e => { e.target.style.left = '8px'; e.target.style.top = '8px'; e.target.style.width = 'auto'; e.target.style.height = 'auto'; e.target.style.overflow = 'visible'; }} onBlur={e => { e.target.style.left = '-9999px'; e.target.style.top = 'auto'; e.target.style.width = '1px'; e.target.style.height = '1px'; e.target.style.overflow = 'hidden'; }}>Skip to main content</a>

      {/* Hero Section */}
      {/* <HeroSection /> */}
      <NewHeroSection />

      {/* Services Preview */}
      {/* <ServicesPreview /> */}
      <ServicesComponent />
      {/* Why Choose Us */}
      {/* <section className="why-choose-section py-20" aria-labelledby="why-choose-title" role="region" aria-label="Why Choose Us">
        <div className="pattern-wave" aria-hidden="true"></div>
        <div className="pattern-dot" aria-hidden="true"></div>
        <div className="pattern-lines" aria-hidden="true"></div>
        <div className="container">
        <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="section-title" id="why-choose-title">
            Why Choose <span className="text-primary-blue">Abraj Al Dhafna</span> for Skilled Manpower & Subcontracts
            </h2>
            <p className="section-subtitle">
              Leading provider of skilled manpower supply and construction subcontracting in Qatar. Certified tradesmen, complete project execution for construction, MEP fit-out. ISO certified. Serving Doha, Lusail, The Pearl, West Bay, and all major sites.
                        </p>
          </motion.div>
          <div className="why-choose-grid">
            Feature Items: Add tabIndex for accessibility
            <motion.div tabIndex={0} initial={{ opacity: 0, x: -50 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }} viewport={{ once: true }} className="feature-item premium-badge">
              <div className="feature-icon" aria-label="24/7 Manpower"><FaBolt /></div>
                  <div className="feature-content">
                    <h4>24/7 Manpower Supply Qatar</h4>
                    <p>Get skilled construction workers on your Qatar project site within 24 hours with our reliable manpower Qatar services</p>
                  </div>
            </motion.div>
            <motion.div tabIndex={0} initial={{ opacity: 0, x: -50 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }} viewport={{ once: true }} className="feature-item">
              <div className="feature-icon" aria-label="ISO Certified"><FaAward /></div>
                  <div className="feature-content">
                    <h4>ISO Certified Construction Company Qatar</h4>
                    <p>All our electricians, plumbers, masons, and welders are certified tradesmen Qatar and experienced in Qatar's construction standards</p>
                  </div>
            </motion.div>
            <motion.div tabIndex={0} initial={{ opacity: 0, x: -50 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }} viewport={{ once: true }} className="feature-item">
              <div className="feature-icon" aria-label="Staff Transportation"><FaBus /></div>
                  <div className="feature-content">
                    <h4>Staff Transportation Services Qatar</h4>
                    <p>Our fleet of 15-seater worker bus covers all Qatar locations including remote construction sites with skilled workers in Lusail</p>
                  </div>
            </motion.div>
            <motion.div tabIndex={0} initial={{ opacity: 0, x: -50 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }} viewport={{ once: true }} className="feature-item">
              <div className="feature-icon" aria-label="Safety Compliant"><FaShieldAlt /></div>
                  <div className="feature-content">
                    <h4>Safety Compliant Manpower Qatar</h4>
                    <p>All workers follow Qatar's strict safety regulations and construction standards as part of our construction helper supply Doha</p>
              </div>
            </motion.div>
          </div>
        </div>
      </section> */}
      <WhyChooseSection />
      {/* Qatar Coverage Areas */}
      {/* <section className="coverage-section py-20 bg-light-gray" aria-labelledby="coverage-title" role="region" aria-label="Qatar Coverage Areas">
        <div className="container">
          <motion.div initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} viewport={{ once: true }} className="text-center mb-16">
            <h2 className="section-title" id="coverage-title">
              Serving <span className="text-primary-blue">All Qatar</span>
            </h2>
            <p className="section-subtitle">
              We provide immediate manpower mobilization across all major areas in Qatar with skilled labor for construction Doha and reliable manpower Qatar
            </p>
          </motion.div>

          <div className="coverage-grid">
            Coverage Items: Add tabIndex for accessibility
            <motion.div tabIndex={0} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.1 }} viewport={{ once: true }} className="coverage-item">
              <FaMapMarkerAlt className="coverage-icon" aria-label="Doha" />
              <h4>Doha</h4>
              <p>Central Doha, West Bay, Corniche, and surrounding areas with construction helper supply Doha</p>
            </motion.div>

            <motion.div tabIndex={0} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.2 }} viewport={{ once: true }} className="coverage-item">
              <FaMapMarkerAlt className="coverage-icon" aria-label="Lusail" />
              <h4>Lusail</h4>
              <p>Lusail City, Marina District, and all Lusail development projects with skilled workers in Lusail</p>
            </motion.div>

            <motion.div tabIndex={0} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.3 }} viewport={{ once: true }} className="coverage-item">
              <FaMapMarkerAlt className="coverage-icon" aria-label="The Pearl" />
              <h4>The Pearl</h4>
              <p>The Pearl-Qatar, Porto Arabia, and all Pearl development areas with certified tradesmen Qatar</p>
            </motion.div>

            <motion.div tabIndex={0} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.4 }} viewport={{ once: true }} className="coverage-item">
              <FaMapMarkerAlt className="coverage-icon" aria-label="Industrial Areas" />
              <h4>Industrial Areas</h4>
              <p>All industrial zones and manufacturing facilities with industrial painting Doha and MEP specialists Qatar</p>
            </motion.div>

            <motion.div tabIndex={0} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.5 }} viewport={{ once: true }} className="coverage-item">
              <FaMapMarkerAlt className="coverage-icon" aria-label="West Bay" />
              <h4>West Bay</h4>
              <p>West Bay business district and commercial buildings with commercial painting services Qatar</p>
            </motion.div>

            <motion.div tabIndex={0} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.6 }} viewport={{ once: true }} className="coverage-item">
              <FaMapMarkerAlt className="coverage-icon" aria-label="All Qatar" />
              <h4>All Qatar</h4>
              <p>Complete coverage across Qatar with staff transportation services Qatar and 15-seater worker bus</p>
            </motion.div>
          </div>
        </div>
      </section> */}
      <CoverageSection />
      {/* Services Overview */}
      {/* <section className="services-overview py-20 bg-white" aria-labelledby="services-title" role="region" aria-label="Comprehensive Construction Services">
        <div className="container">
          <motion.div initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} viewport={{ once: true }} className="text-center mb-16">
            <h2 className="section-title" id="services-title">
              Comprehensive <span className="text-primary-blue">Construction Services</span>
            </h2>
            <p className="section-subtitle">
              From construction manpower supply Qatar to specialized industrial services, we provide complete solutions
            </p>
          </motion.div>

          <div className="services-overview-grid">
            Service Overview Items: Add tabIndex for accessibility
            <motion.div tabIndex={0} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.1 }} viewport={{ once: true }} className="service-overview-item">
              <FaIndustry className="service-overview-icon" aria-label="Industrial Services" />
              <h4>Industrial Services</h4>
              <p>Waterproofing contractors Qatar, epoxy floor coating Qatar, protective coatings Qatar, and anti-corrosion coating Qatar for industrial facilities</p>
            </motion.div>

            <motion.div tabIndex={0} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.2 }} viewport={{ once: true }} className="service-overview-item">
              <FaPaintBrush className="service-overview-icon" aria-label="Painting Contractors" />
              <h4>Painting Contractors Qatar</h4>
              <p>Residential painting services Doha, commercial painting services Qatar, and industrial painting Doha for all project types</p>
            </motion.div>

            <motion.div tabIndex={0} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.3 }} viewport={{ once: true }} className="service-overview-item">
              <FaCog className="service-overview-icon" aria-label="MEP Specialists" />
              <h4>MEP Specialists Qatar</h4>
              <p>MEP maintenance Qatar and MEP specialists for complex mechanical, electrical, and plumbing systems in commercial and industrial facilities</p>
            </motion.div>

            <motion.div tabIndex={0} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.4 }} viewport={{ once: true }} className="service-overview-item">
              <FaHammer className="service-overview-icon" aria-label="Concrete & Construction" />
              <h4>Concrete & Construction</h4>
              <p>Concrete repair Doha, epoxy flooring contractors Qatar, and construction helper supply Doha for all construction projects</p>
            </motion.div>
          </div>
        </div>
      </section> */}
      <ServicesOverview />
      {/* Call to Action */}
      {/* <CallToAction /> */}
      <Cta />
    </main>
  );
};

export default Home; 